import { render, staticRenderFns } from "./WorkforceList.vue?vue&type=template&id=07c03f82&scoped=true&"
import script from "./WorkforceList.vue?vue&type=script&lang=js&"
export * from "./WorkforceList.vue?vue&type=script&lang=js&"
import style0 from "./WorkforceList.vue?vue&type=style&index=0&id=07c03f82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c03f82",
  null
  
)

export default component.exports